// extracted by mini-css-extract-plugin
module.exports = {"cookiesContainer":"Cookies_cookiesContainer__wFSLG","corpContainer":"Cookies_corpContainer__iY41l","mainContainer":"Cookies_mainContainer__14Cdi"};